export default __webpack_public_path__ + "static/media/coc_charadice.1f457a41.png";